import { notification } from "antd";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateSubscription } from "../../redux/slices/subscription";

import { GET } from "../../utils/apiCalls";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { tid } = useParams();

  const showErrorNotification = (message: string, description: string) => {
    notification.error({
      message,
      description,
      duration: 4,
    });
  };

  const finalizeSubscription = async (_tid: any) => {
    try {
      const response: any = await GET(
        `ease-buzz-payment/success/${_tid}`,
        null
      );
      if (response?.id) {
        dispatch(updateSubscription(response));
        notification.success({
          message: "Payment Successful",
          description: "Your subscription has been activated successfully",
          duration: 3,
        });
      } else {
        throw new Error("Payment verification failed");
      }
    } catch (error: any) {
      console.error("Subscription error:", error);
      showErrorNotification(
        "Subscription Failed",
        "Payment was successful but subscription activation failed. Please contact support."
      );
      navigate(`/payment-failure/${tid}`);
    }
  };

  useEffect(() => {
    if (!tid) {
      showErrorNotification(
        "Invalid Request",
        "Something went wrong. Please try again or contact support."
      );
      navigate(`/payment-failure/${tid}`);
    } else {
      finalizeSubscription(tid);
    }
  }, [tid]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
        padding: "20px",
      }}
    >
      <div
        style={{
          maxWidth: "450px",
          width: "100%",
          padding: "40px",
          borderRadius: "8px",
          background: "#fff",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        <h2 style={{ fontSize: "24px", marginBottom: "16px", color: "#333" }}>
          Payment Successful
        </h2>
        <p style={{ fontSize: "16px", marginBottom: "24px", color: "#666" }}>
          Your payment was processed successfully.
        </p>
        <button
          style={{
            padding: "10px 24px",
            fontSize: "16px",
            background: "#1890ff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
